import LoginForm from "../components/LoginForm.jsx";
import styles from './LoginPage.module.css';
import logo from "@shared/assets/logo.svg";



const LoginPage = ({ login, isAuthenticated }) => {
  
  return (
    <div className={styles.container_fluid}>
      <div className={styles.left_container}>
        <div className={styles.logo_big}>
          <img src={logo} alt="Berlin United Logo" />
        </div>
        
        <div className={styles.credits}>
          <p>developed by Berlin United</p>
        </div>
      </div>
      <div className={styles.right_container}>
        <LoginForm route="/api/token/" method="login" />
      </div>
    </div>
  );
};

export default LoginPage;
